import React, { Component } from 'react';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { get } from 'lodash';
import { CUSTOM_CHANNEL_PLATFORMS } from 'constants/channels';

const CustomChannel = styled.div`
    border: 1px solid ${props => props.theme.colors.darkgray};
    margin-top: 20px;
    padding: 10px;
    font-size: 14px;
    color: #656158;

    :hover {
         box-shadow: 0 4px 6px rgba(0,0,0,0.10), 0 4px 6px rgba(0,0,0,0.10);
         border: 1px solid #007DC6;

    }
`;

class CustomChannelView extends Component {
    render() {
        const { embeddedLink = {} } = this.props;
        const name = get(embeddedLink, 'name', null);
        const frameUrl = get(embeddedLink, 'frameUrl', null);
        const platform = get(embeddedLink, 'platform', null);
        const visibleToClient = get(embeddedLink, 'enabled', null);


        return (
            <Row>
                <Col xs={12}>
                    <CustomChannel>
                        <Row>
                            <Col xs={12}><strong>Custom Channel Name</strong></Col>
                            <Col xs={12}>{name}</Col>
                        </Row>
                        <Row>
                            <Col xs={12}><strong>Embed URL</strong></Col>
                            <Col xs={12}><pre>{frameUrl}</pre></Col>
                        </Row>
                        <Row>
                            <Col xs={6}><strong>Platform</strong></Col>
                            <Col xs={6}><strong>Visible to Client</strong></Col>
                        </Row>
                        <Row>
                            <Col xs={6}>{CUSTOM_CHANNEL_PLATFORMS[platform]}</Col>
                            <Col xs={6}>{visibleToClient ? 'Visible' : 'Hidden'}</Col>
                        </Row>
                    </CustomChannel>
                </Col>
            </Row>
        );
    }
}

export default CustomChannelView;



// WEBPACK FOOTER //
// ./src/components/organisms/entity/view/CustomChannelView.js